import './processBlock.css';
import './processBlock.html.twig';
import './processBlockItem.css';
import './processBlockItem.html.twig';

import './circle-01.svg';
import './circle-02.svg';
import './circle-03.svg';
import './circle-04.svg';
import './circle-05.svg';
import './circle-06.svg';
import './circle-07.svg';

export default function() {
  const el = document.querySelector('.process-block');

  if (!el) {
    return;
  }

  const circle = document.querySelector('#js-circle');
  const step1 = el.querySelector('.process-block__item:first-child');
  step1.classList.add('process-block__item--active');
  step1.firstElementChild.nextElementSibling.classList.add('process-block-item--active');

  if ('IntersectionObserver' in window) {
    const config = {
      root: null,
      rootMargin: '-100px',
      threshold: 0.7,
    };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          circle.classList.add('step-0-active');
        } else {
          circle.classList.remove('step-0-active');
        }
      });
    }, config);
    observer.observe(step1);
  }

  const items = [...el.querySelectorAll('.process-block__item')];
  items.forEach((item, i) => {
    item.id = 'step-' + [i];
    item.addEventListener('click', () => {
      const activeItem = [...el.querySelectorAll('.process-block__item--active')];
      activeItem.forEach(active => {
        active.classList.remove('process-block__item--active');
        active.firstElementChild.nextElementSibling.classList.remove('process-block-item--active');
      });
      item.classList.toggle('process-block__item--active');
      item.firstElementChild.nextElementSibling.classList.toggle('process-block-item--active');

      //Circle Shizz
      const itemId = item.id;
      const oldClass = circle.classList.item(1);
      circle.classList.remove(oldClass);
      circle.classList.add(itemId + '-active');
    });

    // Accessibility
    const button = item.querySelector('.process-block-item__button');
    button.addEventListener('click', () => {
      item.click();
    });
  });
}
